module.exports = __webpack_public_path__ + "img/6.762377bd.png";